

import React from 'react'
import heroimg from "../../assets/img/team/petrolpump.jpg";
import moment from "moment-timezone";
import { Card, Col, Container, Row } from "@themesberg/react-bootstrap";

const AboutUs = () => {
    const currentYear = moment().get("year");
    return (
        <div>

            <main className="contents">
                <Card>

                    <section className="my-5 mt-lg-6 mb-lg-5">
                        <Container>
                            <Row className="justify-content-center align-items-center">
                                <Col xs={12} md={6}>
                                    <Card className="border-0">
                                        <Card.Img src={heroimg} className="petrolpump" alt="Petrotec Image" />
                                    </Card>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Card className="bg-white shadow-soft border rounded border-2 p-4 p-lg-5 h-auto">
                                        <h2 className='text-center aboutustitle '>About Us</h2>
                                        <Card.Body>
                                            <p className="software-info">Software Name: PetroPulse</p>
                                            <p className="software-info">Release Version: 1.5.0</p>
                                      
                                            <p className="software-info ">
                                                Copyright © {`${currentYear} `}
                                                <Card.Link href="https://www.petrotec.com/" className="text-blue text-decoration-none fw-normal">
                                                    Petrotec India
                                                </Card.Link>
                                            </p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </Card>
            </main>
        </div>
    )
}

export default AboutUs;

